<div [class.frameFull]="isDraggable" class="iframeBlock" id="iframeBlock">
    <iframe name="dataBricksIframe" #iframe width="100%" height="100%" style="border: 0px;">
    </iframe>
</div>